import React from 'react';
import { IPageItem } from '../../../routes/courseDashboard/features/coursePages/CoursePageList';
import Typography from '@mui/material/Typography/Typography';
import { useQueryParam, NumberParam } from 'use-query-params';

interface IPageNavigationItemProps {
  nodeData: IPageItem;
  onClick: () => void;
}
export default function PageNavigationItem({ nodeData, onClick }: IPageNavigationItemProps) {
  const [, setPageIDParam] = useQueryParam('pageID', NumberParam);
  const { data: page, key: pageID, children } = nodeData;

  if (page.title) {
    return (
      <>
        <div
          onClick={() => {
            setPageIDParam(pageID as number);
            onClick();
          }}
          style={{ minHeight: 30 }}
        >
          <Typography variant='body2' noWrap style={{ textAlign: 'left', color: 'white' }}>
            {page.title.value}
          </Typography>
        </div>
      </>
    );
  } else {
    return <></>;
  }
}
